"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusTrapCallout = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Callout_1 = require("./Callout");
var FocusTrapZone_1 = require("../../FocusTrapZone");
/**
 * A special Callout that uses FocusTrapZone to trap focus
 * @param props - Props for the component
 */
var FocusTrapCallout = function (props) {
    return (React.createElement(Callout_1.Callout, tslib_1.__assign({}, props),
        React.createElement(FocusTrapZone_1.FocusTrapZone, tslib_1.__assign({ disabled: props.hidden }, props.focusTrapProps), props.children)));
};
exports.FocusTrapCallout = FocusTrapCallout;
//# sourceMappingURL=FocusTrapCallout.js.map